<template>
    <flickity ref="flickity" class="text-center orsus-news" :options="flickityOptions">
        <div v-for="(item, index) in news" :key="index" class="carousel-cell w-full mx-4 md:mx-2 p-4 md:p-0">
            <article class="bg-white h-card-xs pt-4 px-8 shadow">
                <img :src="item.imagePath" alt="">
                <p>{{ item.description }}</p>
            </article>
        </div>
    </flickity>
</template>

<script>
import Flickity from 'vue-flickity';
import 'flickity-imagesloaded';

export default {
    components: {
        Flickity
    },
    data() {
        return {
            flickityOptions: {
                imagesLoaded: true,
                groupCells: true
            },
            news: [
                {
                    description: 'Orsus Takes Global Tour to Create Value for Millions of Content Creators Worldwide',
                    imagePath: '/assets/images/orsus_news-1.png'
                },
                {
                    description: 'Orsus Takes Global Tour to Create Value for Millions of Content Creators Worldwide',
                    imagePath: '/assets/images/orsus_news-2.png'
                },
                {
                    description: 'Orsus Takes Global Tour to Create Value for Millions of Content Creators Worldwide',
                    imagePath: '/assets/images/orsus_news-3.png'
                },
                {
                    description: 'Orsus Takes Global Tour to Create Value for Millions of Content Creators Worldwide',
                    imagePath: '/assets/images/orsus_news-1.png'
                },
                {
                    description: 'Orsus Takes Global Tour to Create Value for Millions of Content Creators Worldwide',
                    imagePath: '/assets/images/orsus_news-2.png'
                },
                {
                    description: 'Orsus Takes Global Tour to Create Value for Millions of Content Creators Worldwide',
                    imagePath: '/assets/images/orsus_news-3.png'
                },
            ]
        }
    },
}
</script>